import { ProjectRole } from "@/enums/ProjectRole";
import { z } from "zod";
import { ProjectStatusSchema } from "./ProjectStatus";

export const EntitySchema = z.object({
  entityId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  entityPhone: z.string(),
  extension: z.string(),
  companyName: z.string(),
  companyPhone: z.string(),
  fax: z.string(),
  addressLine1: z.string(),
  addressLine2: z.string(),
  city: z.string(),
  state: z.string().nullable(),
  zip: z.string(),
  webAccountStatus: z.string(),
  active: z.boolean(),
  payee: z.string(),
  bankNumber: z.string(),
  bankAccount: z.string(),
  bankName: z.string(),
  bankCity: z.string(),
  bankABANumber: z.string(),
  user: z.boolean(),
  licensee: z.boolean(),
  primaryLender: z.boolean(),
  send1099s: z.boolean(),
  webAccountReadOnly: z.boolean(),
  fedTaxId: z.string(),
  stateTaxId: z.string(),
});

export const EntityListSchema = z.array(EntitySchema);

export const EntitiesSchema = z.object({
  id: z.string(),
  entity: EntitySchema,
  projectRole: z.nativeEnum(ProjectRole),
  balance: z.number(),
});

export const EntityFileSchema = z.object({
  entityFileId: z.string(),
  entityId: z.string(),
  dateStamp: z.coerce.date(),
  filename: z.string(),
});

export const EntityFileListSchema = z.array(EntityFileSchema);

export const EntityDetailSchema = z.object({
  entity: EntitySchema,
  projects: z.array(
    z.object({
      projectId: z.string(),
      projectCode: z.string(),
      projectName: z.string(),
      projectStatus: ProjectStatusSchema,
    })
  ),
  // files: z.array(EntityFileSchema),
});

export type Entity = z.infer<typeof EntitySchema>;
export type EntityFile = z.infer<typeof EntityFileSchema>;
export type EntityDetail = z.infer<typeof EntityDetailSchema>;
